import { apiFetch } from "./apiFetch";
import { getApiErrorMessage } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export type SettlementType = "Charge" | "Deduction";

function url(companyId: string, documentId: string, suffix: string): string {
  const params = new URLSearchParams({ companyId });
  return `${API_URL}/documents/${encodeURIComponent(documentId)}/${suffix}?${params.toString()}`;
}

async function send(urlValue: string, method: "PATCH" | "POST", data: unknown): Promise<void> {
  const response = await apiFetch(urlValue, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response, "Nie udało się zapisać rozliczenia KSeF."));
  }
}

export async function changeSettlementAmount(
  companyId: string,
  documentId: string,
  lineId: string,
  directUnitCost: number,
): Promise<void> {
  await send(
    url(companyId, documentId, `purchase-lines/${encodeURIComponent(lineId)}/settlement-amount`),
    "PATCH",
    { directUnitCost },
  );
}

export async function changeSettlementFlags(
  companyId: string,
  documentId: string,
  lineId: string,
  flags: { skipInPosting?: boolean; skipInSettlement?: boolean },
): Promise<void> {
  await send(
    url(companyId, documentId, `purchase-lines/${encodeURIComponent(lineId)}/settlement-flags`),
    "PATCH",
    flags,
  );
}

export async function addSettlementLine(
  companyId: string,
  documentId: string,
  settlementType: SettlementType,
  amount: number,
): Promise<void> {
  await send(url(companyId, documentId, "settlement-lines"), "POST", { settlementType, amount });
}
